export const timeStamp = {
	value: new Date(),
};
